import React, { useState } from 'react';
import Navbar from '../components/navbar/Navbar'; // Adjust path if necessary
import Footer from '../components/footer/Footer'; // Adjust path if necessary
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../firebase/Firebase'; // Import your Firebase configuration
import { FaCheckCircle } from 'react-icons/fa'; // Import for tick mark icon

const Form = () => {
    const [staffForm, setStaffForm] = useState({
        realName: '',
        surname: '',
        email: '',
        phone: '',
        discordUsername: '',
        age: '',
        timezone: '',
        minecraftUsername: '',
        experience: '',
        staffRole: '',
        motivation: '',
        ideas: '',
        handleSpam: '',
        handleArgument: '',
        handleReport: '',
        promoteEnvironment: '',
        events: '',
        integrateNewPlayers: '',
        personalQualities: '',
        handleCriticism: '',
        conflictResolution: '',
        additionalInfo: '',
        skills: '',
        moderationTools: '',
    });
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStaffForm((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setShowTerms(true);
    };

    const confirmSubmission = async () => {
        setIsSubmitting(true);
        try {
            await addDoc(collection(db, 'staffApplications'), staffForm);
            setFormSubmitted(true); // Show success message
        } catch (error) {
            console.error('Error adding document: ', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: '#1a1a1a', // Dark background
            color: '#fff', // Light text color
        }}>
            <Navbar />
            <div style={{
                flex: '1', // Allow the form container to grow and shrink
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px',
            }}>
                <div style={{
                    padding: '20px',
                    maxWidth: '600px',
                    width: '100%',
                    background: '#333', // Darker form background
                    borderRadius: '10px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)', // Stronger shadow for depth
                }}>
                    {!formSubmitted ? (
                        <>
                            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Staff Application Form</h2>
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    name="realName"
                                    value={staffForm.realName}
                                    onChange={handleChange}
                                    placeholder="Real Name"
                                    required
                                    style={{
                                        marginBottom: '10px',
                                        padding: '10px',
                                        width: '100%',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#444', // Input background
                                        color: '#fff', // Input text color
                                    }}
                                />
                                <input
                                    type="text"
                                    name="surname"
                                    value={staffForm.surname}
                                    onChange={handleChange}
                                    placeholder="Surname"
                                    required
                                    style={{
                                        marginBottom: '10px',
                                        padding: '10px',
                                        width: '100%',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#444', // Input background
                                        color: '#fff', // Input text color
                                    }}
                                />
                                <input
                                    type="email"
                                    name="email"
                                    value={staffForm.email}
                                    onChange={handleChange}
                                    placeholder="Email Address"
                                    required
                                    style={{
                                        marginBottom: '10px',
                                        padding: '10px',
                                        width: '100%',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#444', // Input background
                                        color: '#fff', // Input text color
                                    }}
                                />
                                <input
                                    type="tel"
                                    name="phone"
                                    value={staffForm.phone}
                                    onChange={handleChange}
                                    placeholder="Phone Number"
                                    required
                                    style={{
                                        marginBottom: '10px',
                                        padding: '10px',
                                        width: '100%',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#444', // Input background
                                        color: '#fff', // Input text color
                                    }}
                                />
                                <input
                                    type="text"
                                    name="discordUsername"
                                    value={staffForm.discordUsername}
                                    onChange={handleChange}
                                    placeholder="Discord Username and Tag"
                                    required
                                    style={{
                                        marginBottom: '10px',
                                        padding: '10px',
                                        width: '100%',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#444', // Input background
                                        color: '#fff', // Input text color
                                    }}
                                />
                                <input
                                    type="number"
                                    name="age"
                                    value={staffForm.age}
                                    onChange={handleChange}
                                    placeholder="Age"
                                    required
                                    style={{
                                        marginBottom: '10px',
                                        padding: '10px',
                                        width: '100%',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#444', // Input background
                                        color: '#fff', // Input text color
                                    }}
                                />
                                <input
                                    type="text"
                                    name="timezone"
                                    value={staffForm.timezone}
                                    onChange={handleChange}
                                    placeholder="Time Zone"
                                    required
                                    style={{
                                        marginBottom: '10px',
                                        padding: '10px',
                                        width: '100%',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#444', // Input background
                                        color: '#fff', // Input text color
                                    }}
                                />
                                <input
                                    type="text"
                                    name="minecraftUsername"
                                    value={staffForm.minecraftUsername}
                                    onChange={handleChange}
                                    placeholder="Minecraft Username"
                                    required
                                    style={{
                                        marginBottom: '10px',
                                        padding: '10px',
                                        width: '100%',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#444', // Input background
                                        color: '#fff', // Input text color
                                    }}
                                />
                                {/* Other input fields for the form */}
                                <textarea
                                    name="experience"
                                    value={staffForm.experience}
                                    onChange={handleChange}
                                    placeholder="Experience with Minecraft"
                                    required
                                    style={{
                                        marginBottom: '10px',
                                        padding: '10px',
                                        width: '100%',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#444', // Input background
                                        color: '#fff', // Input text color
                                    }}
                                />
                                <textarea
                                    name="staffRole"
                                    value={staffForm.staffRole}
                                    onChange={handleChange}
                                    placeholder="Role Applying For"
                                    required
                                    style={{
                                        marginBottom: '10px',
                                        padding: '10px',
                                        width: '100%',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#444', // Input background
                                        color: '#fff', // Input text color
                                    }}
                                />
                                {/* Add all other text areas here with required */}
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        style={{
                                            padding: '10px 20px',
                                            backgroundColor: '#4CAF50',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                        }}>
                                        {isSubmitting ? 'Submitting...' : 'Submit Application'}
                                    </button>
                                </div>
                            </form>
                            {showTerms && (
                                <div style={{
                                    marginTop: '20px',
                                    padding: '10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '5px',
                                    backgroundColor: '#444', // Darker terms background
                                }}>
                                    <p>Please read and accept the terms and conditions to proceed with the submission.</p>
                                    <h3>Terms and Conditions</h3>
                                    <p>PowerGames Network Staff Application Terms and Conditions<br />
                                        Effective Date: 11/10/2024<br />
                                        1. You must be 16 years or older to apply.<br />
                                        2. You must have experience with Minecraft.<br />
                                        3. You agree to follow all server rules and guidelines.<br />
                                        4. You understand that your application may take time to be reviewed.<br />
                                        5. You agree to be respectful and courteous at all times.<br />
                                    </p>
                                    <label style={{ display: 'flex', alignItems: 'center' }}>
                                        <input
                                            type="checkbox"
                                            checked={termsAccepted}
                                            onChange={() => setTermsAccepted(!termsAccepted)}
                                            style={{ marginRight: '10px' }}
                                        />
                                        I accept the terms and conditions.
                                    </label>
                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                                        <button
                                            onClick={confirmSubmission}
                                            disabled={!termsAccepted || isSubmitting}
                                            style={{
                                                padding: '10px 20px',
                                                backgroundColor: '#4CAF50',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '5px',
                                                cursor: 'pointer',
                                            }}>
                                            Confirm Submission
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <FaCheckCircle size={48} color="#4CAF50" />
                            <h3>Application Submitted Successfully!</h3>
                            <p style={{ textAlign: 'center' }}>
                                Thank you for your submission! Please check your application status in the <a href="/portal" style={{ color: '#4CAF50', textDecoration: 'underline' }}>Portal</a>.
                            </p>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Form;
